import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ImageUtil } from '../../../common/utils/imageUtil';

const TrustedSiteItem = ({ item }) => {
  const {
    wr_id,
    wr_subject,
    wr_name,
    member_info,
    wr_site_name,
    wr_deposit,
    wr_operation_start,
    wr_verification_period,
    wr_note,
    wr_banner_url,
  } = item;

  const authorIcon =
    (member_info?.is_admin || ['mp', 'mng', 'ad', 'jail', 'leave'].includes(member_info?.level))
      ? `/img/lv/23/${['mp', 'mng', 'ad', 'jail', 'leave'].includes(member_info?.level) ? member_info.level : 'mp'}.png`
      : `/img/lv/23/${member_info.gender === 'm' ? `m${member_info.level}` : `f${member_info.level}`}.png`;
  const authorImage = ImageUtil.imageUrl(authorIcon, 100, 100);

  return (
    <StyledLink to={`/trusted_site/detail?id=${wr_id}&type=trusted_site`}>
      <Container>
        <ThumbImage src={wr_banner_url} alt={wr_subject} />
        <Info>
          <SiteName>{wr_site_name}</SiteName>
          <RowContainer>
            <Label>가입코드 :</Label>
            <Value>{wr_note}</Value>
          </RowContainer>
        </Info>
      </Container>
    </StyledLink>
  );
};

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #333;

  &:visited {
    color: #999;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #f4f4f4;
  padding: 12px 8px;
  gap: 8px;
  align-items: center;

  @media (min-width: 768px) {
    border-bottom: 0px;
  }
`;

const ThumbImage = styled.img`
  //width: 100%;
  //max-width: 250px;
  //height: auto;
  width: 165px;
  height: 124px;
  object-fit: cover;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  //width: 100%;
  flex: 1;
  align-items: center;
  text-align: center;
`;

const SiteName = styled.span`
  font-size: 16px;
  font-weight: bolder;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  font-size: 12px;
  color: #333;
  justify-content: center;
`;

const Label = styled.div`
  font-size: 12px;
  color: #222;
  font-weight: bold;
`;

const Value = styled.div`
  font-size: 12px;
  color: #333;
  word-break: break-word;
  flex: 1;
  /*NOS-967*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export default TrustedSiteItem;
